import { ChiliOffIcon } from './ChiliOffIcon';

/**
 * author: Michael Irigoyen
 * id F92E010E-F45D-44CE-8F13-F6419010B0D2
 * name chili-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chili-off.svg
 * tags
 * - Food / Drink 
 */
export const ChilliOffIcon = ChiliOffIcon;
export default ChilliOffIcon